@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
}

.account {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
